var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-container"},[_c('h1',[_vm._v("Policy Needs Attention")]),_c('policy-list',{attrs:{"isFulfilled":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }